import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalConfirmModule } from '@rsm/components/modal-confirm/modal-confirm.module';

import { RsmFormsModule } from '@rsm/shared/form';
import { AuthClientModule } from '@rsm/client/auth-client';

import { CompanySetupComponent } from './company-setup.component';
import { CompanySetupRoutingModule } from './company-setup-routing';
import { CompanySetupAddressComponent } from './company-setup-signin/company-setup-address/company-setup-address.component';
import { CompanySetupSocialMediaComponent } from './company-setup-signin/company-setup-social-media/company-setup-social-media.component';
import { CardModule } from '@rsm/components/card/card.module';
import { NgxMaskModule } from 'ngx-mask';
import { StepIndicatorModule } from '@rsm/components/step-indicator';
import { NgSelectModule } from '@ng-select/ng-select';
import { CompanySetupPlanComponent } from './company-setup-plan/company-setup-plan.component';
import { CompanySetupSigninComponent } from './company-setup-signin/company-setup-signin.component';
import { CompanySetupInfoComponent } from './company-setup-signin/company-setup-info/company-setup-info.component';
import { NumericInputModule } from '@rsm/components/numeric-input';
import { PixPaymentPanelModule } from '@rsm/components/pix-payment-panel';
import { CompanySetupCheckoutComponent } from './company-setup-checkout/company-setup-checkout.component';
import { QRCodeModule } from 'angularx-qrcode';
import { CompanySetupWaitingComponent } from './company-setup-waiting/company-setup-waiting.component';
import { AwaitingContactComponent } from './awaiting-contact/awaiting-contact.component';

@NgModule({
  declarations: [
    CompanySetupComponent,
    CompanySetupInfoComponent,
    CompanySetupAddressComponent,
    CompanySetupSocialMediaComponent,
    CompanySetupPlanComponent,
    CompanySetupSigninComponent,
    CompanySetupCheckoutComponent,
    CompanySetupWaitingComponent,
    AwaitingContactComponent,
  ],
  imports: [
    CommonModule,
    RsmFormsModule,
    AuthClientModule,
    CompanySetupRoutingModule,
    CardModule,
    NgxMaskModule,
    StepIndicatorModule,
    NumericInputModule,
    NgSelectModule,
    QRCodeModule,
    PixPaymentPanelModule,
    FormsModule,
    ModalConfirmModule,
    MatDialogModule,
  ],
})
export class CompanySetupModule {}
